import { useState, useEffect } from 'react';

function usePagination10(totalItems, initialRowsPerPage = 10) {
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
    const [currentPage, setCurrentPage] = useState(1); // Página atual

    useEffect(() => {
        setCurrentPage(1);
    }, [totalItems]);

    const totalPages = Math.ceil(totalItems / rowsPerPage);

    // Calcula o startIndex com base na página atual
    const startIndex = (currentPage - 1) * rowsPerPage;

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const goToFirstPage = () => goToPage(1);
    const goToPreviousPage = () => goToPage(currentPage - 1);
    const goToNextPage = () => goToPage(currentPage + 1);
    const goToLastPage = () => goToPage(totalPages);

    return {
        setPagination: {
            totalItems,
            rowsPerPage,
            startIndex,
            currentPage, // Retorna a página atual
            totalPages, // Retorna o número total de páginas
            onRowsPerPageChange: (e) => {
                setRowsPerPage(Number(e.target.value));
                setCurrentPage(1); // Volta para a primeira página ao alterar o número de itens por página
            },
            onFirstItems: goToFirstPage,
            onPreviousItems: goToPreviousPage,
            onNextItems: goToNextPage,
            onLastItems: goToLastPage,
            onGoToPage: goToPage, // Função para ir para uma página específica
        },
    };
}

export default usePagination10;